import { useRecoilValue, useSetRecoilState } from "recoil";
import { CardHeight, CardWidth, DragCard } from "../api/CardApi";
import { Box } from "@mui/material";

const ranks = [
    "Back",
    "Ace",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Jack",
    "Queen",
    "King",
  ],
  suits = ["Blue", "Hearts", "Spades", "Diamonds", "Clubs"];

function PlayingCard({ rank, suit, cardType, ...other }) {
  const cardHeight = useRecoilValue(CardHeight),
    cardWidth = useRecoilValue(CardWidth),
    setDragCard = useSetRecoilState(DragCard);

  return (
    <Box {...other} sx={{ height: cardHeight, width: cardWidth }}>
      <img
        alt={`${ranks[rank]} ${suits[suit]}`}
        draggable
        loading="lazy"
        src={`https://gamenightblob.blob.core.windows.net/cards/${ranks[rank]}${suits[suit]}.svg`}
        style={{ height: "100%", width: "100%" }}
        onDragEnd={() => {
          setDragCard(null);
        }}
        onDragStart={() => {
          setDragCard({
            cardType: cardType,
            rank: rank,
            suit: suit,
          });
        }}
      />
    </Box>
  );
}

export default PlayingCard;
